import { render, staticRenderFns } from "./processDetail.vue?vue&type=template&id=fd6a595c&"
import script from "./processDetail.vue?vue&type=script&lang=js&"
export * from "./processDetail.vue?vue&type=script&lang=js&"
import style0 from "./processDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports